import { Component } from '@angular/core';

@Component({
  selector: 'app-help-message',
  templateUrl: './help-message.component.html',
  styleUrls: ['./help-message.component.scss'],
})
export class HelpMessageComponent {}